/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Edit_Tag_LabelInputs */

const en_tags_manager_edit_tag_label = /** @type {(inputs: Tags_Manager_Edit_Tag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Tag`)
};

const fr_tags_manager_edit_tag_label = /** @type {(inputs: Tags_Manager_Edit_Tag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier le tag`)
};

const de_tags_manager_edit_tag_label = /** @type {(inputs: Tags_Manager_Edit_Tag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag bearbeiten`)
};

const it_tags_manager_edit_tag_label = /** @type {(inputs: Tags_Manager_Edit_Tag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica tag`)
};

const ru_tags_manager_edit_tag_label = /** @type {(inputs: Tags_Manager_Edit_Tag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактировать тег`)
};

const es_tags_manager_edit_tag_label = /** @type {(inputs: Tags_Manager_Edit_Tag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar etiqueta`)
};

const zh_cn2_tags_manager_edit_tag_label = /** @type {(inputs: Tags_Manager_Edit_Tag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑标签`)
};

const ja_tags_manager_edit_tag_label = /** @type {(inputs: Tags_Manager_Edit_Tag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグを編集`)
};

const hi_tags_manager_edit_tag_label = /** @type {(inputs: Tags_Manager_Edit_Tag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टैग संपादित करें`)
};

const pt_pt2_tags_manager_edit_tag_label = /** @type {(inputs: Tags_Manager_Edit_Tag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar etiqueta`)
};

/**
* | output |
* | --- |
* | "Edit Tag" |
*
* @param {Tags_Manager_Edit_Tag_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_edit_tag_label = /** @type {((inputs?: Tags_Manager_Edit_Tag_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Edit_Tag_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_edit_tag_label(inputs)
	if (locale === "de") return de_tags_manager_edit_tag_label(inputs)
	if (locale === "it") return it_tags_manager_edit_tag_label(inputs)
	if (locale === "ru") return ru_tags_manager_edit_tag_label(inputs)
	if (locale === "es") return es_tags_manager_edit_tag_label(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_edit_tag_label(inputs)
	if (locale === "ja") return ja_tags_manager_edit_tag_label(inputs)
	if (locale === "hi") return hi_tags_manager_edit_tag_label(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_edit_tag_label(inputs)
	return en_tags_manager_edit_tag_label(inputs)
});